// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'Arial', sans-serif;
  background: none !important;
  margin: 0;
  padding: 0;
}

.home-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  color: #ffffff;
}

/* Background Video */
.video-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: -1; /* Keeps the video behind other content */
}

/* Ensures the content stays above the video */
.header, .form-container {
  position: relative;
  z-index: 1;
}


.header h1 {
  font-size: 3em;
  margin: 0;
  color: #ffffff;
  text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
}

.header p {
  font-size: 1.2em;
  color: #e0f7ff;
  margin-top: 10px;
  font-weight: 300;
}

.form-container {
  background-color: transparent;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 90%;
  margin-top: -50px;
  text-align: center;
  display: flex;
  flex-direction: column; /* Stack fields vertically */
  gap: 5px; /* Add consistent spacing between elements */
}

.input-label {
  display: block;
  font-size: 1.1em;
  color: #ffffff;
  text-align: left;
  margin-bottom: 2px;
}

.input-field {
  width: 100%;
  padding: 10px;
  font-size: 1em;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-sizing: border-box;
  margin-bottom: 5px; 
}


.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px; /* Space between logos */
  margin-bottom: 10px; /* Adjust spacing */
}

.input-field:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0px 0px 6px rgba(74, 144, 226, 0.4);
}

.next-button {
  width: 100%;
  padding: 10px;
  font-size: 1.1em;
  color: #ffffff;
  background-color: #007acc;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.3s ease;
}

.next-button:hover {
  background-color: #005fa3;
}

.next-button:active {
  background-color: #004a7f;
}

.next-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.signup-link {
  color: #007acc;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 5px;
  display: block;
  text-align: center;
}

.signup-link:hover {
  color: #005fa3;
}

.home-logo {
  width: 350px;
  height: auto;
}


.admin-button-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
}
 
.admin-access-button {
  background-color: transparent;
  color: white;
  padding: 10px 16px;
  border: 2px solid white;
  border-radius: 6px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;
  backdrop-filter: blur(2px);
}
 
.admin-access-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: #fff;
}



.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease-in-out;
}

.modal-content {
  background: #fff;
  padding: 30px 35px;
  border-radius: 16px;
  text-align: center;
  max-width: 420px;
  width: 90%;
  color: #333;
  font-family: 'Segoe UI', sans-serif;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.4s ease;
}

.modal-content h2 {
  margin-bottom: 12px;
  font-size: 24px;
  color: #1a73e8;
}

.modal-content p {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 25px;
  color: #444;
}

.modal-content button {
  padding: 10px 22px;
  background: #1a73e8;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.modal-content button:hover {
  background: #0c5ed7;
}

/* Optional Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/HomePage.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,WAAW,EAAE,yCAAyC;AACxD;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,UAAU;AACZ;;;AAGA;EACE,cAAc;EACd,SAAS;EACT,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB,EAAE,4BAA4B;EACpD,QAAQ,EAAE,4CAA4C;AACxD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS,EAAE,wBAAwB;EACnC,mBAAmB,EAAE,mBAAmB;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;AACpB;;;;AAIA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF","sourcesContent":["body {\r\n  font-family: 'Arial', sans-serif;\r\n  background: none !important;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.home-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 100vh;\r\n  text-align: center;\r\n  color: #ffffff;\r\n}\r\n\r\n/* Background Video */\r\n.video-background {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  object-fit: cover;\r\n  z-index: -1; /* Keeps the video behind other content */\r\n}\r\n\r\n/* Ensures the content stays above the video */\r\n.header, .form-container {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n\r\n.header h1 {\r\n  font-size: 3em;\r\n  margin: 0;\r\n  color: #ffffff;\r\n  text-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.header p {\r\n  font-size: 1.2em;\r\n  color: #e0f7ff;\r\n  margin-top: 10px;\r\n  font-weight: 300;\r\n}\r\n\r\n.form-container {\r\n  background-color: transparent;\r\n  padding: 30px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  max-width: 400px;\r\n  width: 90%;\r\n  margin-top: -50px;\r\n  text-align: center;\r\n  display: flex;\r\n  flex-direction: column; /* Stack fields vertically */\r\n  gap: 5px; /* Add consistent spacing between elements */\r\n}\r\n\r\n.input-label {\r\n  display: block;\r\n  font-size: 1.1em;\r\n  color: #ffffff;\r\n  text-align: left;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.input-field {\r\n  width: 100%;\r\n  padding: 10px;\r\n  font-size: 1em;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  box-sizing: border-box;\r\n  margin-bottom: 5px; \r\n}\r\n\r\n\r\n.logo-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 30px; /* Space between logos */\r\n  margin-bottom: 10px; /* Adjust spacing */\r\n}\r\n\r\n.input-field:focus {\r\n  outline: none;\r\n  border-color: #4a90e2;\r\n  box-shadow: 0px 0px 6px rgba(74, 144, 226, 0.4);\r\n}\r\n\r\n.next-button {\r\n  width: 100%;\r\n  padding: 10px;\r\n  font-size: 1.1em;\r\n  color: #ffffff;\r\n  background-color: #007acc;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  margin-top: 10px;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.next-button:hover {\r\n  background-color: #005fa3;\r\n}\r\n\r\n.next-button:active {\r\n  background-color: #004a7f;\r\n}\r\n\r\n.next-button:disabled {\r\n  background-color: #cccccc;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.signup-link {\r\n  color: #007acc;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  margin-top: 5px;\r\n  display: block;\r\n  text-align: center;\r\n}\r\n\r\n.signup-link:hover {\r\n  color: #005fa3;\r\n}\r\n\r\n.home-logo {\r\n  width: 350px;\r\n  height: auto;\r\n}\r\n\r\n\r\n.admin-button-container {\r\n  position: fixed;\r\n  top: 20px;\r\n  right: 20px;\r\n  z-index: 9999;\r\n}\r\n \r\n.admin-access-button {\r\n  background-color: transparent;\r\n  color: white;\r\n  padding: 10px 16px;\r\n  border: 2px solid white;\r\n  border-radius: 6px;\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n  transition: all 0.3s ease;\r\n  backdrop-filter: blur(2px);\r\n}\r\n \r\n.admin-access-button:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  color: #fff;\r\n  border-color: #fff;\r\n}\r\n\r\n\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.55);\r\n  z-index: 9999;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  animation: fadeIn 0.3s ease-in-out;\r\n}\r\n\r\n.modal-content {\r\n  background: #fff;\r\n  padding: 30px 35px;\r\n  border-radius: 16px;\r\n  text-align: center;\r\n  max-width: 420px;\r\n  width: 90%;\r\n  color: #333;\r\n  font-family: 'Segoe UI', sans-serif;\r\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);\r\n  animation: slideUp 0.4s ease;\r\n}\r\n\r\n.modal-content h2 {\r\n  margin-bottom: 12px;\r\n  font-size: 24px;\r\n  color: #1a73e8;\r\n}\r\n\r\n.modal-content p {\r\n  font-size: 16px;\r\n  line-height: 1.6;\r\n  margin-bottom: 25px;\r\n  color: #444;\r\n}\r\n\r\n.modal-content button {\r\n  padding: 10px 22px;\r\n  background: #1a73e8;\r\n  border: none;\r\n  border-radius: 8px;\r\n  color: white;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.modal-content button:hover {\r\n  background: #0c5ed7;\r\n}\r\n\r\n/* Optional Animations */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(30px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0px);\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
